import { ContentItemFragmentFragment } from '@lopo-tech/lopo-api'
import replaceAsciiEmojis from 'emoji-shortcuts'
import * as React from 'react'
import BlurredContent, { IBlurred } from 'src/components/blurred_content/blurred_content'
import NavigationItem from 'src/components/navigation_item/navigation_item'
import { CLASS_PREFIX } from 'src/constants/'
import { escapeForMarkup } from 'src/utils/safe_url/safe_url'
import './teaser.scss'

export type IProps = {
  teaser: ContentItemFragmentFragment['teaser'];
  blurred?: false | IBlurred;
  postDetailsURL: string;
};

export const cls = `${CLASS_PREFIX}body-text__preview`

export const Teaser: React.FC<IProps> = ({ blurred = false, teaser, postDetailsURL }) => {
  if (!teaser) {
    return null
  }

  // The teaser is plain text, never markup: escaped here so a body that
  // carries a tag is shown as the text it is.
  //
  // The order is not interchangeable and the replacement has to run first, as
  // it does here. Measured against the package's own alias table: every
  // shortcut built from a character that escaping rewrites - the quote marks
  // as much as the angle brackets - is read in this order and missed in the
  // other, because by then it has become an entity. Most shortcuts contain no
  // such character and come out identical either way, which is what makes the
  // wrong order look harmless to anyone who tries it on one of those.
  const parsedBody: string = escapeForMarkup(replaceAsciiEmojis(teaser))
  const bodyElement = <p dangerouslySetInnerHTML={{ __html: parsedBody }} />

  return (
    <NavigationItem target="_self" url={postDetailsURL}>
      <div className={cls}>
        {blurred
          ? (
            <BlurredContent>{bodyElement}</BlurredContent>
          )
          : (
            bodyElement
          )}
      </div>
    </NavigationItem>
  )
}
